module.exports = __webpack_public_path__ + "static/img/BlackBerry@2x.ec5c029.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sodastream/BlackBerry@2x.png
// module id = BdyW
// module chunks = 0